import { Injectable, inject } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { CommonService } from '../services/common.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private commonService = inject(CommonService);

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
  const authHeader = request.headers.get('Authorization');
  const applicationId = this.commonService.getApplicationId();

  const setHeaders: any = {
    ...(applicationId != null && applicationId !== ''
      ? { application: String(applicationId) }
      : {}),
    isBoxOffice:
      this.commonService.isOpenSuperbFromAttendeeAPP ||
      this.commonService.isOpenSuperbFromBoxOfficeAPP
        ? '1'
        : '0',
    originType: this.commonService.originType
  };

  if (!authHeader && this.commonService.token !== '') {
    setHeaders.Authorization = `Bearer ${this.commonService.token}`;
  }

  request = request.clone({
    setHeaders: setHeaders
  });
  
  return next.handle(request);
  }
}
